export default __webpack_public_path__ + "static/media/2290.c9816f70.png";